import {interactiveStateConfigs} from "../../configs/interactiveStateConfigs";
import {useInteractiveGameState} from "../../hooks/useInteractiveGameState";


export const InteractiveStateManager = ({children}) => {
    useInteractiveGameState(interactiveStateConfigs);
    return children;
}
